export default __webpack_public_path__ + "static/media/ErpPackage.97f6e9a4.png";